/**
 * Peor token oficial entre status, power_status y server_status.
 * Sirve para la tarjeta del área Vultr: muestra el estado de Vultr, no Ready/Unavailable.
 */
const WORST_FIRST = [
  'suspended',
  'locked',
  'stopped',
  'resizing',
  'pending',
  'installingbooting',
  'isomounting',
  'none',
]

export function vultrHeadline(instances) {
  if (!instances?.length) return null
  const tokens = new Set()
  for (const row of instances) {
    if (row.instanceStatus && row.instanceStatus !== '—') {
      tokens.add(row.instanceStatus)
    }
    if (row.powerStatus && row.powerStatus !== '—') tokens.add(row.powerStatus)
    if (row.serverStatus && row.serverStatus !== '—') {
      tokens.add(row.serverStatus)
    }
  }
  for (const token of WORST_FIRST) {
    if (tokens.has(token)) return token
  }
  const healthy = instances.every(
    (row) =>
      row.instanceStatus === 'active' &&
      row.powerStatus === 'running' &&
      row.serverStatus === 'ok',
  )
  return healthy ? 'active' : null
}
